import { api } from './api';

/** One whole address path, as the catalog knows it. */
export interface AddressSearchResult {
  key: string;
  province: string;
  cityMunicipality: string | null;
  barangay: string | null;
}

/**
 * Address paths matching what someone typed.
 *
 * In `lib/` rather than a feature folder because `<AddressPicker>` is a shared input and a
 * shared component must not import from `features/` — the same reason `verifyPassword` sits
 * beside it rather than in the auth slice.
 */
export function searchAddresses(
  query: string,
  signal?: AbortSignal,
  take = 20,
): Promise<AddressSearchResult[]> {
  return api<AddressSearchResult[]>(
    `/api/addresses/search?q=${encodeURIComponent(query)}&take=${take}`,
    { signal },
  );
}

/**
 * `Rizal, Antipolo, Bagong Nayon` — the one way a path is written, for every surface.
 *
 * **Commas, not `›`.** It read as a hierarchy path while the picker was the only thing
 * showing it; it is now the address itself, on profile rows and in the create form’s summary,
 * and an address is written with commas. The chevron stays where it belongs — the breadcrumb,
 * which really is a path through the product rather than a value.
 */
export function addressPathLabel(parts: {
  province?: string | null;
  cityMunicipality?: string | null;
  barangay?: string | null;
}): string {
  return [parts.province, parts.cityMunicipality, parts.barangay].filter(Boolean).join(', ');
}
